(function () {
	function normalize(str) {
		return (str || '').toLowerCase();
	}

	function queryAllIncludingSelf(scope, selector) {
		var results = Array.prototype.slice.call(scope.querySelectorAll(selector));
		if (scope.matches && scope.matches(selector)) {
			results.push(scope);
		}
		return results;
	}

	function initList(root) {
		if (root.__kcFaqReady) return;
		root.__kcFaqReady = true;

		var menu = root.querySelector('[data-kc-faq-menu]');
		var menuItems = menu ? Array.prototype.slice.call(menu.querySelectorAll('[data-kc-faq-menu-item]')) : [];
		var groups = Array.prototype.slice.call(root.querySelectorAll('[data-kc-faq-group]'));
		var emptyState = root.querySelector('[data-kc-faq-empty]');
		var activeCategory = 'all';
		var searchTerm = '';

		function applyFilters() {
			var term = normalize(searchTerm);
			var anyVisible = false;

			groups.forEach(function (group) {
				var groupCategory = group.getAttribute('data-kc-faq-group');
				var inCategory = activeCategory === 'all' || groupCategory === activeCategory;
				var groupHasVisible = false;

				Array.prototype.slice.call(group.querySelectorAll('[data-kc-faq-item]')).forEach(function (item) {
					var haystack = normalize(item.getAttribute('data-kc-faq-search'));
					var matches = inCategory && (term === '' || haystack.indexOf(term) !== -1);
					item.hidden = !matches;
					if (matches) groupHasVisible = true;
				});

				group.hidden = !groupHasVisible;
				if (groupHasVisible) anyVisible = true;
			});

			if (emptyState) {
				emptyState.hidden = anyVisible;
			}
		}

		menuItems.forEach(function (button) {
			button.addEventListener('click', function () {
				activeCategory = button.getAttribute('data-kc-faq-menu-item');
				menuItems.forEach(function (other) {
					other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
				});
				applyFilters();
			});
		});

		Array.prototype.slice.call(root.querySelectorAll('[data-kc-faq-item]')).forEach(function (details) {
			details.addEventListener('toggle', function () {
				if (details.open && details.id) {
					history.replaceState(null, '', '#' + details.id);
				}
			});
		});

		function openFromHash() {
			var hash = window.location.hash.slice(1);
			if (!hash) return;

			var target = null;
			try {
				target = root.querySelector('#' + CSS.escape(hash));
			} catch (err) {
				target = null;
			}
			if (!target) return;

			target.open = true;
			window.setTimeout(function () {
				var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
				window.scrollTo({ top: top, behavior: 'smooth' });
			}, 0);
		}

		root.__kcFaqSetSearch = function (value) {
			searchTerm = value;
			applyFilters();
		};

		root.__kcFaqOpenBlock = function (blockId) {
			var details = root.querySelector('[data-block-id="' + blockId + '"]');
			if (details) {
				details.open = true;
				details.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		};

		openFromHash();
		window.addEventListener('hashchange', openFromHash);
	}

	function initSearch(hero) {
		if (hero.__kcFaqSearchReady) return;
		hero.__kcFaqSearchReady = true;

		var input = hero.querySelector('[data-kc-faq-search]');
		if (!input) return;

		var timer = null;
		input.addEventListener('input', function () {
			var value = input.value;
			window.clearTimeout(timer);
			timer = window.setTimeout(function () {
				var list = document.querySelector('[data-kc-faq-list]');
				if (list && typeof list.__kcFaqSetSearch === 'function') {
					list.__kcFaqSetSearch(value);
				}
			}, 120);
		});
	}

	function initAll(scope) {
		scope = scope || document;
		queryAllIncludingSelf(scope, '[data-kc-faq-list]').forEach(initList);
		queryAllIncludingSelf(scope, '[data-kc-faq-hero]').forEach(initSearch);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});

	document.addEventListener('shopify:block:select', function (event) {
		var list = document.querySelector('[data-kc-faq-list]');
		if (list && typeof list.__kcFaqOpenBlock === 'function') {
			list.__kcFaqOpenBlock(event.detail.blockId);
		}
	});
})();
